import { NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { FormGroup, FormsModule, UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';
import { FuseCardComponent } from '@fuse/components/card';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import Swal from 'sweetalert2';
 
@Component({
  standalone: true,
  selector: 'app-cancel-service',
  templateUrl: './cancel-service.component.html',
  styleUrls: ['./cancel-service.component.scss'],
  imports: [NgFor, MatSelectModule, MatDialogModule, MatDatepickerModule, FuseAlertComponent, FuseCardComponent, MatProgressSpinnerModule, MatButtonModule, NgIf, NgFor, FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDatepickerModule]
})

export class CancelServiceComponent {
  public cancelled: boolean = false;
  public packageDetails: any;
  public availablePackages: [];
  public loading: boolean = true;
  public cancellationReasonsList: any;
  public minDate: string;
  public maxDate: string;
  public comment: string;
  public cancellationForm: UntypedFormGroup;
  public leadNotes: any;
  public requiresAdditionalInformation: boolean = false;

  private regradeResult: any;
  public regradeOptions: any[] = [];

  private cancellationResult: any

  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;
  

  constructor(
    private _sharedServices: SharedServiceService,
    private _sharedMethods: SharedMethodsModule,
    public dialogRef: MatDialogRef<CancelServiceComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){

  }

   ngOnInit(){
    this.cancellationForm = this.formBuilder.group({
      suggestedImprovements: [''],
      additionalInformation: [''],
      reason: ['', Validators.required],
      date: ['', Validators.required],
    });
     this.packageDetails = this._sharedServices.activeCustomerServices;

     this.getServiceCancellation();

     this.getRegradeCancellationOptions()

   }
 
   public closeDialog(){
     this.dialogRef.close();
   }

   public closeCancelServiceConfirmationDialog() {
    this.dialogRef.close();
    location.reload()
   }

   public resonChanged(val: any) {
    if (val.value.RequiresAdditionalInformation) {
      this.requiresAdditionalInformation = true;

      this.cancellationForm.get('additionalInformation').setValidators([Validators.required]);
      this.cancellationForm.get('additionalInformation').updateValueAndValidity();
    } else {
      this.requiresAdditionalInformation = false
    }
   }

   public async cancelService(){
    this.loading = true

    if (this.cancellationForm.value.suggestedImprovements) {
      this.leadNotes = 'Suggested Improvements: ' + this.cancellationForm.value.suggestedImprovements
    }
    if (this.cancellationForm.value.additionalInformation) {
      this.leadNotes = this.leadNotes + '\n' +  'Additional Information: ' + this.cancellationForm.value.additionalInformation
    }
    
    const data = {
      LeadActionTypeCode: 'ServiceCancellation',
      LeadDescription: 'Service Cancellation',
      UpdatingEntityAccountOfferableID: this.data?.EntityAccountOfferableEntityID,
      IsFeasibilityLead: false,
      CancellationReasonID: this.cancellationForm.value.reason.CancellationReasonID,
      LeadCompletionMethod: 'FutureDated',
      FutureCompletionDate: this.cancellationForm.value.date,
      LeadNotes: this.leadNotes
    }

    this.cancellationResult = await this._sharedMethods.cancelService(data);

    if(this.cancellationResult) {
      this.loading = false;
      this.cancelled = true;
      Swal.fire({
        title: 'Service Cancellation',
        text: 'Service cancellation request has been succesfully sent',
        icon: 'success',
        confirmButtonText: 'Okay',
        customClass: {
          confirmButton: 'text-lg text-black bg-accent',
        },
    }).then(() => {
      this.closeDialog();
      location.reload(); //Force refresh
    })

    } else {
      this.cancellationForm.reset();

      this.alert = {
        type: 'error',
        message: this.cancellationResult.error.error.Message
      }

      this.showAlert = true
    }
   }

   private async getRegradeCancellationOptions() {
    this.regradeResult = await this._sharedMethods.GetRegrades(this.data?.EntityAccountOfferableEntityID, 'ServiceCancellation');

    if (this.regradeResult) {
      this.regradeOptions = this.regradeResult?.result?.RegradeDateOptions
      this.minDate = this.regradeOptions[0]?.RegradeDate
      this.maxDate = this.regradeOptions[4]?.RegradeDate
    }
   }
 
   private async getServiceCancellation(){

    
     this._sharedMethods.getServiceCancellationReasons().then((res) => {
      this.cancellationReasonsList = res?.result;       
     }).finally(()=>{
      this.loading = false;
     });
   }

 }

 
